/**
 * Created by DejanK on 8/02/2017.
 */
'use strict';

let lodash = require('lodash');

module.exports = {
  template: require('./rb-negotiation-view-rate-cell.html'),
  bindings: {
    negotiations: '<',
    negotiation: '<',
    rateId: '@'
  },
  controller: Ctrl
};

Ctrl.$inject = ['$element', '$scope', 'NegotiationsHtmlFactory', '$rootScope'];
function Ctrl($element, $scope, NegotiationsHtmlFactory, $rootScope) {
  let vm = this;

  vm.$onInit = $onInit;
  vm.$onChanges = $onChanges;

  vm.onMouseEnter = onMouseEnter;
  vm.onMouseLeave = onMouseLeave;


  function $onInit(){
    $scope.$on('RB_NEGOTIATIONS_MOUSE_ENTER', onMouseEnterScopeEvent);
    $scope.$on('RB_NEGOTIATIONS_MOUSE_LEAVE', onMouseLeaveScopeEvent);
  }

  function $onChanges(changes){
    changes.negotiation && changes.negotiation.currentValue && vm.rateId && setupVm(changes.negotiation.currentValue, vm.rateId );

    function setupVm(negotiation, rateId){
      vm.negotiation = negotiation;
      vm.rate = negotiation.getRate(rateId);
      vm.rateValue = vm.rate.getFormattedValue();
      vm.rateChangeClass = NegotiationsHtmlFactory.buildChangeNotificationClass(vm.rate.change);
    }
  }

  function onMouseEnter(){
    $rootScope.$broadcast('RB_NEGOTIATIONS_MOUSE_ENTER', {cellId: vm.rateId})
  }

  function onMouseLeave(){
    $rootScope.$broadcast('RB_NEGOTIATIONS_MOUSE_LEAVE', {cellId: vm.rateId})
  }

  function onMouseEnterScopeEvent(event, data){
    if(data.cellId === vm.rateId) $element.addClass('highlight');
  }

  function onMouseLeaveScopeEvent(event, data){
    if(data.cellId === vm.rateId) $element.removeClass('highlight');
  }
}
